import React, { useMemo } from "react";
import BarGraph from "../../Marketplace/barGraph";
import RadialChart from "../../Marketplace/radialCHart";
import { useTranslation } from "next-i18next";
import {
  useGetMarketplaceEntryExitDominance,
  useGetMarketplaceLongShortDominance,
} from "@/api/marketPlaceApi";
type Props = {};

export default function GraphSection({}: Props) {
  const { t } = useTranslation("marketplace-page");
  const { data: longShortDominance } = useGetMarketplaceLongShortDominance();
  const { data: entryExitDominance } = useGetMarketplaceEntryExitDominance();

  const tradesTriggeredWinloss = useMemo(() => {
    const totalWinTrades = longShortDominance?.long || 0;
    const totalLossTrades = longShortDominance?.short || 0;
    const totalTrades = totalWinTrades + totalLossTrades;

    const winPercentage =
      totalTrades > 0
        ? Number(((totalWinTrades / totalTrades) * 100).toFixed(1))
        : 0;
    const lossPercentage =
      totalTrades > 0
        ? Number(((totalLossTrades / totalTrades) * 100).toFixed(1))
        : 0;

    return [
      { name: "Long", value: winPercentage },
      { name: "Short", value: lossPercentage },
    ];
  }, [longShortDominance]);

  const tradesTriggeredEntryExit = useMemo(() => {
    const totalWinTrades = entryExitDominance?.opened || 0;
    const totalLossTrades = entryExitDominance?.closed || 0;
    const totalTrades = totalWinTrades + totalLossTrades;

    const winPercentage =
      totalTrades > 0
        ? Number(((totalWinTrades / totalTrades) * 100).toFixed(1))
        : 0;
    const lossPercentage =
      totalTrades > 0
        ? Number(((totalLossTrades / totalTrades) * 100).toFixed(1))
        : 0;

    return [
      { name: "Entry", value: winPercentage },
      { name: "Exit", value: lossPercentage },
    ];
  }, [entryExitDominance]);

  return (
    <div className="relative w-full flex-col flex sm:flex-row h-full">
      <div className="w-full sm:w-[77%]">
        <BarGraph />
      </div>
      <div
        className="w-full sm:w-[23%] flex sm:flex-col lg:justify-between mt-5 sm:mt-0 items-center"
        id="marketplace-graphs"
      >
        <div className="w-full h-[50%] max-w-[250px]">
          {Object.keys(tradesTriggeredEntryExit).length && (
            <RadialChart
              title={t("Entry/Exit Dominance")}
              backtestGraphRes={tradesTriggeredEntryExit}
              t={t}
              totalTrades={
                entryExitDominance?.opened + entryExitDominance?.closed
              }
            />
          )}
        </div>
        <div className="w-full flex flex-col items-center max-w-[250px]">
          <div className="text-[12px] flex text-center items-center mt-0 pt-0 font-semibold">
            {t("Long/Short Dominance")}
          </div>
          <div className="flex items-center  w-full max-w-[100px] justify-start mt-3">
            <div
              className={`w-[42px] h-[42px] bg-[var(--foreground-green)] rounded-full flex items-center justify-center mr-5`}
            >
              L
            </div>
            <div className="text-sm">{tradesTriggeredWinloss[0]?.value}%</div>
          </div>

          <div className="flex items-center  w-full max-w-[100px] justify-start mt-3">
            <div
              className={`w-[42px] h-[42px] bg-[var(--foreground-red)] rounded-full flex items-center justify-center mr-5`}
            >
              S
            </div>
            <div className="text-sm">{tradesTriggeredWinloss[1]?.value}%</div>
          </div>
        </div>
      </div>
    </div>
  );
}
